var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5C10 4.96957 10.2107 4.46086 10.5858 4.08579C10.9609 3.71071 11.4696 3.5 12 3.5C12.5304 3.5 13.0391 3.71071 13.4142 4.08579C13.7893 4.46086 14 4.96957 14 5.5C15.1484 6.04303 16.1274 6.88833 16.8321 7.9453C17.5367 9.00227 17.9404 10.2311 18 11.5V14.5C18.0753 15.1217 18.2954 15.7171 18.6428 16.2381C18.9902 16.7592 19.4551 17.1914 20 17.5H4C4.54494 17.1914 5.00981 16.7592 5.35719 16.2381C5.70457 15.7171 5.92474 15.1217 6 14.5V11.5C6.05956 10.2311 6.4633 9.00227 7.16795 7.9453C7.8726 6.88833 8.85159 6.04303 10 5.5",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.5V18.5C9 19.2956 9.31607 20.0587 9.87868 20.6213C10.4413 21.1839 11.2044 21.5 12 21.5C12.7956 21.5 13.5587 21.1839 14.1213 20.6213C14.6839 20.0587 15 19.2956 15 18.5V17.5",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellMenu);
export default __webpack_public_path__ + "static/media/bell-menu.35148602fdd717f27f43f6532fa952d5.svg";
export { ForwardRef as ReactComponent };